export const statusMap = {
  applied: {
    label: 'Applied',
    disabled: true,
  },
  apply: {
    label: 'Apply now',
    disabled: false,
  },
  inProgress: {
    label: 'Continue',
    disabled: false,
  },
};

export function getApplicationStatus(applicationStatuses = [], id) {
  const applicationStatus = applicationStatuses.find((status) => status.opportunityId === id);

  return applicationStatus?.status;
}

export function mapButtonStatus(status, hasAppliedForService) {
  if (hasAppliedForService) {
    return statusMap.applied;
  }
  switch (status) {
    case 'Awaiting Application Form':
      return statusMap.inProgress;
    case 'Awaiting Age Verification':
      return statusMap.inProgress;
    case 'Checks In Progress':
      return statusMap.applied;
    case 'Completed':
      return statusMap.applied;
    // TODO: The below to be discussed as they need to be confirmed by the customer
    case 'Discontinued':
      return statusMap.apply;
    case 'Suspended':
      return statusMap.apply;
    case 'On Hold':
      return statusMap.applied;
    case 'Unsuccessful':
      return statusMap.apply;
    default:
      return statusMap.apply;
  }
}

export function mapRotueStatus(status) {
  switch (status) {
    case 'Awaiting Application Form':
      return statusMap.inProgress.disabled;
    case 'Awaiting Age Verification':
      return statusMap.inProgress.disabled;
    case 'Checks In Progress':
      return statusMap.applied.disabled;
    case 'Completed':
      return statusMap.applied.disabled;
    // TODO: The below to be discussed as they need to be confirmed by the customer
    case 'Discontinued':
      return statusMap.apply.disabled;
    case 'Suspended':
      return statusMap.apply.disabled;
    case 'On Hold':
      return statusMap.applied.disabled;
    case 'Unsuccessful':
      return statusMap.apply.disabled;
    default:
      return statusMap.apply.disabled;
  }
}

export default function getStatus(
  applicationStatuses = [],
  assignmentsData = [],
  opportunityData = {},
  id,
  opts = { statusOnly: false },
) {
  if (!id) {
    throw new Error('OpportunityId must be provided');
  }

  const applicationStatus = getApplicationStatus(applicationStatuses, id);

  if (opts.statusOnly) {
    return mapRotueStatus(applicationStatus);
  }

  const myServicesIds = assignmentsData.map((assignment) => assignment.serviceId);

  const opportunityServiceId = opportunityData.serviceId;

  const hasAppliedForService = myServicesIds.includes(opportunityServiceId);

  return mapButtonStatus(applicationStatus, hasAppliedForService);
}
